<div class="wrapper">
  <div class="d-flex flex-row align-items-center w-100 dialog-title">
    <div class="d-flex justify-content-center w-100">
      <h2 class="my-3" mat-dialog-title>Sign in</h2>
    </div>
    <mat-icon [mat-dialog-close]="true" class="material-symbols-outlined close">close</mat-icon>
  </div>
  <form [formGroup]="loginForm" class="pb-3">
    <div class="d-flex flex-column justify-content-center align-items-center px-2 px-sm-5">
      <mat-form-field class="mt-4">
        <input type="email"
          placeholder="Email Address"
          aria-label="Email"
          matInput
          formControlName="email"
          autocomplete="email"
          required>
        </mat-form-field>
        <mat-form-field class="">
          <input type="password"
            placeholder="Password"
            aria-label="Password"
            matInput
            formControlName="password"
            autocomplete="current-password"
            required>
          </mat-form-field>
          <button class="accent small-btn" (click)="login()">
            @if (!(spinner$ | async)?.show) {
              Login
            }
            @if ((spinner$ | async)?.show) {
              <div class="d-flex justify-content-center w-100">
                <span class="spinner">
                  <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="small" color="#fff" type="ball-spin-clockwise" [fullScreen]="false"></ngx-spinner>
                </span>
              </div>
            }
          </button>
          <mat-error class="text-center mt-3 mb-2">{{loginErrorMessage}}{{errorMessage}}</mat-error>
          <div class="d-flex justify-content-center w-100 pt-3">
            <button mat-button class="link" (click)="forgotPassword()">
              Forgot Password?
            </button>
          </div>
          <div class="divider mt-4 w-100"></div>
        </div>
      </form>
      <div class="d-flex justify-content-center align-items-center flex-column w-100 px-2 px-sm-5 pt-3 mb-4">
        <p>New Customer?</p>
        <button class="primary small-btn" (click)="register()">
          Register
        </button>
      </div>
    </div>
